import type { SVGProps } from 'react';

interface LadderIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const LadderIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & LadderIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 48 48"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#ladder_svg__a)">
      <path
        d="M15.023 17.554H33.71v4.53H15.023zM15.023 26.615H33.71v4.53H15.023zM15.023 35.675H33.71v4.53H15.023z"
        fill="#fff"
      />
      <rect
        fill="#B0CEFC"
        height={34.542}
        rx={0.849}
        width={1.699}
        x={15.023}
        y={12.458}
      />
      <rect
        fill="#B0CEFC"
        height={34.542}
        rx={0.849}
        width={1.699}
        x={33.711}
        y={12.458}
      />
      <path
        d="M24.103 2.621a.6.6 0 0 1 1.097 0l1.068 2.26 2.39.363c.5.076.7.72.338 1.09l-1.729 1.76.408 2.483c.086.522-.438.92-.887.674l-2.137-1.174-2.136 1.174c-.449.246-.974-.152-.888-.674l.408-2.484-1.729-1.76c-.363-.369-.162-1.013.34-1.09l2.388-.362z"
        fill="#B0CEFC"
      />
      <path
        d="M7.096 47H4.831A2.83 2.83 0 0 1 2 44.169v-33.41a2.83 2.83 0 0 1 2.831-2.831h2.265M41.638 47h2.265a2.83 2.83 0 0 0 2.831-2.831v-33.41a2.83 2.83 0 0 0-2.831-2.831h-2.265"
        stroke="#4FA9FF"
        strokeLinecap="round"
        strokeWidth={2.265}
      />
    </g>
    <defs>
      <clipPath id="ladder_svg__a">
        <path d="M0 0h48v48H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
